import { useQuery } from "react-query";
import { useConfig } from "../../utils/useConfig";
import { Transaction } from "../../models";
import { fetchData } from "../../utils/fetchData";
import { Pagination } from "../../models";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useData } from "../../utils/useData";

export const useEmployeeTransactions = (employeeId: string) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employerId } = useData();

    return useQuery<Pagination<Transaction>>(
        `${config?.API_URL}/transactions?employeeId=${employeeId}`,
        () => fetchData(
            `${config?.API_URL}/transactions`,
            getToken,
            `employeeId=${employeeId}&employerId=${employerId}`
        )
    );
}